import { Box, Button, IconButton, Typography } from "@mui/material";
import AppBarContainer from "../../components/shared/AppBarContainer";
import PageContentContainer from "../../components/shared/PageContentContainer";
import { useEffect, useState } from "react";
import { BalootUserAPIs, BalootUserV2APIs } from "../../api/APIs";
import { useRequest } from "../../api/utils/useRequest";
import { useLocation, useNavigate } from "react-router-dom";
import ArrowForward from "@mui/icons-material/ArrowForward";
import AmountLargeBox from "../../components/shared/AmountLargeBox";
import { toToman } from "../../utils/Utils";
import BalootKeyboard from "../../components/shared/BalootKeyboard";
import CustomTextSkeleton from "../../components/shared/CustomTextSkeleton";
import CustomRectangularSkeleton from "../../components/shared/CustomRectangularSkeleton";
import CashoutBankBox from "../../components/cashout/CashoutBankBox";
import BottomFullWidthButtonContainer from "../../components/shared/BottomFullWidthButtonContainer";
import { CashoutBottomSheet } from "../../components/cashout/CashoutBottomSheet";
import { LoadingButton } from "@mui/lab";
import { ReactComponent as CalendarIcon } from "../../assets/icons/day-calendar-colored.svg";
import { ActionModal } from "../../components/shared/ActionModal";
import ErrorMessageText from "../../components/shared/ErrorMessageText";
import { useSnackBar } from "../../context/SnackBarContext";

function CashoutPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const openSnack = useSnackBar();
  const walletId = location.state?.walletId;

  const [editedAmount, setEditedAmount] = useState(0);

  const [iban, setIban] = useState(null);
  const [open, setOpen] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const {
    loading: preLoading,
    result,
    apiCall: preCashoutInfo,
  } = useRequest(BalootUserV2APIs.preCashoutInfo, true);

  const { loading, apiCall: cashout } = useRequest(BalootUserAPIs.cashout);

  const onSubmit = () => {
    if (!iban) {
      openSnack(true, { message: "شماره شبای خود را وارد کنید" });
      return;
    }
    if (editedAmount * 10 < result.config.minAmount) {
      setErrorMessage(
        `مقدار وارد شده از حداقل مبلغ (${toToman(
          result.config.minAmount
        )} تومان) کمتر است.`
      );
      return;
    }
    if (editedAmount * 10 > result.wallet.amount) {
      setErrorMessage(`مقدار وارد شده از موجودی قابل برداشت بیش‌تر است.`);
      return;
    }

    cashout({
      data: { walletId, amount: editedAmount * 10 },
      onSuccess: () => {
        navigate("success");
      },
    });
  };

  useEffect(() => {
    preCashoutInfo({
      data: { walletId },
      onSuccess: (response) => {
        if (!response.birthdateValidated) {
          setOpenModal(true);
        }
        setIban(response.iban?.substring(2));
        setEditedAmount(
          Math.round(
            response.config.minAmount ? response.config.minAmount / 10 : 0
          )
        );
      },
    });
  }, []);

  useEffect(() => {
    !!errorMessage && setErrorMessage("");
  }, [editedAmount]);

  return (
    <>
      <AppBarContainer
        rightElement={
          <IconButton onClick={() => navigate(-1)}>
            <ArrowForward sx={{ color: "common.white" }} />
          </IconButton>
        }
        centerElement={
          <Typography variant="h5" color={"common.white"}>
            برداشت
          </Typography>
        }
      />

      <PageContentContainer
        sx={{
          overflow: "auto",
          display: "block",
          pb: `calc(env(safe-area-inset-bottom) + 112px )`,
        }}
      >
        <Box
          sx={{
            mb: "12px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="body2" color="grey.2">
            موجودی قابل برداشت
          </Typography>
          {preLoading ? (
            <CustomTextSkeleton width={100} />
          ) : (
            result && (
              <Typography component={"div"} variant="h5" color="grey.2">
                {toToman(result.wallet.amount)}{" "}
                <Box
                  sx={{
                    display: "inline",
                    color: "grey.3",
                    typography: "subtitle1",
                  }}
                >
                  تومان
                </Box>
              </Typography>
            )
          )}
        </Box>
        <AmountLargeBox amount={editedAmount * 10} error={!!errorMessage} />
        <Box minHeight={80}>
          <ErrorMessageText errorMessage={errorMessage} sx={{ mt: 1 }} />
          {preLoading ? (
            <CustomRectangularSkeleton sx={{ mt: 1 }} height={40} />
          ) : (
            result && (
              <CashoutBankBox
                setIban={setIban}
                iban={iban}
                banks={result.banks}
                onClick={() => {
                  setOpen(true);
                }}
              />
            )
          )}
        </Box>
        <BalootKeyboard sx={{ mt: 3 }} setAmount={setEditedAmount} />
        <BottomFullWidthButtonContainer>
          <LoadingButton
            onClick={onSubmit}
            loading={loading}
            disabled={preLoading}
            sx={{
              color: "common.white",
              typography: "h3",
            }}
            variant="contained"
            fullWidth
          >
            برداشت
          </LoadingButton>
        </BottomFullWidthButtonContainer>
      </PageContentContainer>
      {result && (
        <>
          <CashoutBottomSheet
            open={open}
            setIban={setIban}
            setOpen={setOpen}
            iban={result.iban?.substring(2)}
            banks={result.banks}
          />
          <ActionModal
            open={openModal}
            setOpen={setOpenModal}
            icon={CalendarIcon}
            title="تاریخ تولد"
            description="برای برداشت پول از قلک بلوط لازم است تاریخ تولدتان را مطابق شناسنامه وارد کنید."
            isContained
            actionTitle="وارد کردن"
            action={() => {
              navigate("/app/profile/setting/personal");
            }}
            cancelTitle="بستن"
            cancelAction={() => {
              navigate(-1);
            }}
          />
        </>
      )}
    </>
  );
}

export default CashoutPage;
